module.exports = __webpack_public_path__ + "img/background.7912a59d.png";